import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { UseMutationOptions } from "@tanstack/react-query";
import {
  DiscountCodeValidationResult,
  Subscription,
  buildSubscriptionsApiWithToken,
} from "@rentablo/api/apiv1";
import { useAuthMutation } from "@rentablo/api";

export const useCashbackCode = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code") || "";

  useEffect(() => {
    if (code) {
      localStorage.setItem("cashbackCode", code);
    }
  }, [code]);

  return code || localStorage.getItem("cashbackCode") || "";
};

const validateCashbackCode = async (
  token: string | undefined,
  code: string
) => {
  const api = await buildSubscriptionsApiWithToken();

  const { data } = await api.validateDiscountCode({
    discountCode: code,
  });
  return data;
};

export const useValidateCashbackCode = (
  options?: UseMutationOptions<
    DiscountCodeValidationResult,
    AxiosApiError,
    string
  >
) => {
  return useAuthMutation(validateCashbackCode, options);
};

export const saveCashbackCode = async (
  token: string | undefined,
  { subscriptionId, code }: { subscriptionId: number; code: string }
) => {
  const api = await buildSubscriptionsApiWithToken();

  const { data } = await api.updateSubscription({
    id: subscriptionId,
    createOrUpdateSubscriptionParams: {
      discountCode: code,
    },
  });

  return data;
};

export const useSaveCashbackCode = (
  options?: UseMutationOptions<
    Subscription,
    AxiosApiError,
    { subscriptionId: number; code: string }
  >
) => {
  return useAuthMutation(saveCashbackCode, options);
};
